import { render } from "./Clubs.vue?vue&type=template&id=fe47e298&scoped=true"
import script from "./Clubs.vue?vue&type=script&lang=js"
export * from "./Clubs.vue?vue&type=script&lang=js"

import "./Clubs.vue?vue&type=style&index=0&id=fe47e298&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe47e298"]])

export default __exports__